import Reflux from 'reflux'

export default Reflux.createActions(['userSetFormTreeChanged','treeLabelChanged']);


// WEBPACK FOOTER //
// ./src/actions/UserSetActions.js